import React from 'react';
import PropTypes from 'prop-types';
import { ContextualSaveBar, Modal, Text } from '@shopify/polaris';

const UnsavedChanges = ({ confirmingExit, dirty, saving, onSave, onDiscard, onKeep, onLeave }) => (
  <>
    {dirty && (
      <ContextualSaveBar
        message="Unsaved changes"
        saveAction={{ onAction: onSave, loading: saving, disabled: saving }}
        discardAction={{
          content: 'Discard',
          onAction: onDiscard,
          discardConfirmationModal: true,
        }}
      />
    )}

    <Modal
      open={confirmingExit}
      title="Leave without saving?"
      onClose={onKeep}
      primaryAction={{ content: 'Keep editing', onAction: onKeep }}
      secondaryActions={[{ content: 'Leave and lose changes', destructive: true, onAction: onLeave }]}
    >
      <Modal.Section>
        <Text as="p">
          Your changes have not been saved yet. Leaving now discards them.
        </Text>
      </Modal.Section>
    </Modal>
  </>
);

UnsavedChanges.propTypes = {
  confirmingExit: PropTypes.bool,
  dirty: PropTypes.bool,
  onDiscard: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

export default UnsavedChanges;
